const camelToSnake = str => {
  return str.replace(/[A-Z]/g, c => '_' + c.toLowerCase())
}

export const shallowObjectKeysToSnake = obj => {
  const snake = {}
  for (const [key, value] of Object.entries(obj)) {
    snake[camelToSnake(key)] = value
  }

  return snake
}

export const getFormattedFilterString = filters => {
  const filterValuesList = []
  filters?.map(filter => filterValuesList.push(filter.name || filter.label))
  return filterValuesList.join(', ')
}

export const formatCandidateDetailsForTracking = candidate => {
  const rolesAndExperience = []

  candidate.roles.map(role => {
    const experience = role.experience.min + '-' + role.experience.max
    const roleAndExperience = role.title + ' | ' + experience
    rolesAndExperience.push(roleAndExperience)
  })

  const formattedCandidateDetails = {
    title: candidate.roles[0].title,
    skills: candidate.skills.join(', '),
    roles: rolesAndExperience.join(', '),
    locations: candidate.cities.join(', '),
    salaryEu: candidate.salary.eu,
    salaryZa: candidate.salary.za,
  }

  return formattedCandidateDetails
}
